import {Injectable} from '@angular/core'
import{ HttpErrorResponse, HttpEvent,HttpHandler,HttpInterceptor,HttpRequest, HttpResponse} from '@angular/common/http'
import { AuthserviceService } from '../guard/authservice.service'
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
@Injectable()
export class AuthInterceptor  implements HttpInterceptor{ 

    constructor(private auth: AuthserviceService,public router: Router,){}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(this.auth.getToken()){
            request = request.clone({
                setHeaders: { Authorization: 'bearer ' + this.auth.getToken()}
            });
        }
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if(event.status==401){
                        this.router.navigate(['/login']);
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {

                if(error.status==401)
                {

                    this.router.navigate(['/login']);
                }
                return throwError(error);
            }));
    }  
}
